export enum WebsiteEnvironment {
  ALIAS = 'alias',
  SUB = 'sub',
}

export enum StagingEnv {
  CLONE = 'clone',
  NEW = 'new',
  EMPTY = 'empty',
}

export interface CreateWebsiteDTO {
  originServer: string;
  domain: string;
  userId: string;
  groupId: number | null | undefined;
  excludeActions: string[];
}

export interface CreateMainWebsiteDTO {
  originServer: string;
  domain: string;
  userId: string;
  // groupId: number | null | undefined;
  excludeActions: string[];
  plan: number; // This is plan id
}

export interface CreateWebsiteSubdomainDTO {
  websiteId: number;
  domain: string;
  userId?: string;
  websiteEnvironment: WebsiteEnvironment;
  excludeActions: string[];
}

export interface CreateWebsiteAliasDTO {
  websiteId: number;
  domain: string;
  userId?: string;
  websiteEnvironment: WebsiteEnvironment;
  excludeActions: string[];
}

export interface CreateWebsiteStagingDTO {
  websiteId: number;
  websiteEnvironment: StagingEnv;
  userId: string;
}
